module.exports = __webpack_public_path__ + "img/e.e5db8ffc.jpg";